import AppStore from "./AppStore";
import { buildClassName } from "./util";

// id: "3bf618c4-833b-48b3-aead-09aad8d16985"
// title: ""
// type: :gf_preset
// key: "copyright"
// parent_id: "18fccb74-fb2d-4645-81b7-e6c814fab600"
export function Copyright3bf618c4833b48b3Aead09aad8d16985(props: any) {
  const GroupCopyright = AppStore.presets["GroupCopyright"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <GroupCopyright className="Copyright3bf618c4833b48b3Aead09aad8d16985" parentTag={buildClassName("Copyright3bf618c4833b48b3Aead09aad8d16985", parentTag)} {...props} />
  );
}

// id: "0f74c648-66d4-4f57-a803-64a906f8bd2a"
// title: ""
// type: :gf_preset
// key: "groupflow"
// parent_id: "18fccb74-fb2d-4645-81b7-e6c814fab600"
export function Groupflow0f74c64866d44f57A80364a906f8bd2a(props: any) {
  const GroupFlowTag = AppStore.presets["GroupFlowTag"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <GroupFlowTag className="Groupflow0f74c64866d44f57A80364a906f8bd2a" parentTag={buildClassName("Groupflow0f74c64866d44f57A80364a906f8bd2a", parentTag)} {...props} />
  );
}

// id: "2c4cf8c0-f530-4e52-9bef-c7cf27961c1a"
// title: ""
// type: :text
// key: "logoType"
// parent_id: "e534dcd9-8b85-4d28-a55f-2b54fcd41267"
export const LogoType2c4cf8c0F5304e529befC7cf27961c1a = "FOOTER";

// id: "e534dcd9-8b85-4d28-a55f-2b54fcd41267"
// title: ""
// type: :gf_preset
// key: "logo"
// parent_id: "18fccb74-fb2d-4645-81b7-e6c814fab600"
export function LogoE534dcd98b854d28A55f2b54fcd41267(props: any) {
  const Logo = AppStore.presets["Logo"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <Logo className="LogoE534dcd98b854d28A55f2b54fcd41267" parentTag={buildClassName("LogoE534dcd98b854d28A55f2b54fcd41267", parentTag)} logoType="FOOTER" contentSlug="footer-logo" {...props} />
  );
}

// id: "18fccb74-fb2d-4645-81b7-e6c814fab600"
// title: "Footer"
// type: :html
// key: "default-footer"
// parent_id: nil
export function DefaultFooter18fccb74Fb2d464581b7E6c814fab600(props: any) {
  const Navigation = AppStore.presets["Navigation"];
  const Logo = AppStore.presets["Logo"];
  const GroupCopyright = AppStore.presets["GroupCopyright"];
  const GroupFlowTag = AppStore.presets["GroupFlowTag"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <footer className={`${parentTag || ""} DefaultFooter18fccb74Fb2d464581b7E6c814fab600 footer`}>
      {props["links"] || <Navigation className="Links8302162dEdda414cA4185cf2069ad6bc" parentTag={buildClassName("Links8302162dEdda414cA4185cf2069ad6bc", parentTag)} navMenuSlug="footer-nav" {...props} />}
      <div className="logo-wrapper">
        {props["logo"] || <Logo className="LogoE534dcd98b854d28A55f2b54fcd41267" parentTag={buildClassName("LogoE534dcd98b854d28A55f2b54fcd41267", parentTag)} logoType="FOOTER" contentSlug="footer-logo" {...props} />}
      </div>
      {props["copyright"] || <GroupCopyright className="Copyright3bf618c4833b48b3Aead09aad8d16985" parentTag={buildClassName("Copyright3bf618c4833b48b3Aead09aad8d16985", parentTag)} {...props} />}
      {props["groupflow"] || <GroupFlowTag className="Groupflow0f74c64866d44f57A80364a906f8bd2a" parentTag={buildClassName("Groupflow0f74c64866d44f57A80364a906f8bd2a", parentTag)} {...props} />}
    </footer>
  );
}

// id: "8302162d-edda-414c-a418-5cf2069ad6bc"
// title: ""
// type: :gf_preset
// key: "links"
// parent_id: "18fccb74-fb2d-4645-81b7-e6c814fab600"
export function Links8302162dEdda414cA4185cf2069ad6bc(props: any) {
  const Navigation = AppStore.presets["Navigation"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <Navigation className="Links8302162dEdda414cA4185cf2069ad6bc" parentTag={buildClassName("Links8302162dEdda414cA4185cf2069ad6bc", parentTag)} navMenuSlug="footer-nav" {...props} />
  );
}

// id: "26b27ebd-23e6-4c1c-a78d-438bfee6cdb1"
// title: ""
// type: :text
// key: "contentSlug"
// parent_id: "e534dcd9-8b85-4d28-a55f-2b54fcd41267"
export const ContentSlug26b27ebd23e64c1cA78d438bfee6cdb1 = "footer-logo";

// id: "a3df1f3d-a59c-4f3c-8380-3cb03adcedce"
// title: ""
// type: :text
// key: "navMenuSlug"
// parent_id: "8302162d-edda-414c-a418-5cf2069ad6bc"
export const NavMenuSlugA3df1f3dA59c4f3c83803cb03adcedce = "footer-nav";

const Components = {
  Copyright3bf618c4833b48b3Aead09aad8d16985,
  Groupflow0f74c64866d44f57A80364a906f8bd2a,
  LogoType2c4cf8c0F5304e529befC7cf27961c1a,
  LogoE534dcd98b854d28A55f2b54fcd41267,
  DefaultFooter18fccb74Fb2d464581b7E6c814fab600,
  Links8302162dEdda414cA4185cf2069ad6bc,
  ContentSlug26b27ebd23e64c1cA78d438bfee6cdb1,
  NavMenuSlugA3df1f3dA59c4f3c83803cb03adcedce
}

export default Components;